module.exports = __webpack_public_path__ + "img/apm-diners.4c3f7ede.svg";